import { MetadataField, MetadataFieldType } from '@/api/generatedApi';

export const getMetadataFieldType = (value: string | number | boolean, field?: MetadataField): MetadataFieldType => {
  if (field?.type) return field.type as MetadataFieldType;
  if (typeof value === 'string') return MetadataFieldType.Text;
  if (typeof value === 'number') return MetadataFieldType.Number;
  return MetadataFieldType.Boolean;
};
